import { configureStore } from "@reduxjs/toolkit";
import categorySlice from "./slices/categorySlice";
import MasterSlice from "./slices/MasterSlice";
import userSlice from "./slices/userSlice";
import productSlice from "./slices/productSlice";
import contactUsSlice from "./slices/contactUsSlice";

import DashboradCountSlice from "./slices/DashboradCountSlice";
const store = configureStore({
    reducer: {
        masterslice: MasterSlice,
        users: userSlice,
        // category: categorySlice,
        product: productSlice,
        contact: contactUsSlice,
      
        DashboradCountSlice:DashboradCountSlice,
    },
});

export default store;
